import { captureAction } from '@smg-real-estate/browser-rum';

// Maximum time in milliseconds for a metric to be considered as a bad event
export const OVERTIME_THRESHOLD = {
  FILE_UPLOAD: 30000,
  PRICING_API: 5000,
} as const;

export const METRICS = {
  // Pricing parameters
  PRICING_PARAMETERS_CALL_STARTED: 'pricing-parameters-call-started',
  PRICING_PARAMETERS_CALL_SUCCEEDED: 'pricing-parameters-call-succeeded',
  PRICING_PARAMETERS_CALL_FAILED: 'pricing-parameters-call-failed',
  //Pricing Bundles
  PRICING_API_CALL_STARTED: 'pricing-api-call-started',
  PRICING_API_CALL_SUCCESS: 'pricing-api-call-success',
  PRICING_API_CALL_FAILED: 'pricing-api-call-failed',
  PRICING_API_CALL_OVERTIME: 'pricing-api-call-overtime',
  PRICING_API_CALL_RECOVERED: 'pricing-api-call-recovered',
  //Image upload
  FILE_UPLOAD_STARTED: 'file-upload-started',
  FILE_UPLOAD_SUCCESS: 'file-upload-success',
  FILE_UPLOAD_FAILURE: 'file-upload-failure',
  FILE_UPLOAD_OVERTIME: 'file-upload-overtime',
  FILE_UPLOAD_RECOVERED: 'file-upload-recovered',
  //  PPA Chatbot
  PPA_CHATBOT_STARTED: 'ppa-chatbot-started',
  PPA_CHATBOT_SUCCESS: 'ppa-chatbot-success',
  PPA_CHATBOT_FAILED: 'ppa-chatbot-failed',
  USER_NOT_FOUND: 'insertion-funnel-user-not-found',
} as const;

export function pricingBundlesCallStarted() {
  captureAction(METRICS.PRICING_API_CALL_STARTED);
}

export function pricingBundlesCallSuccess() {
  captureAction(METRICS.PRICING_API_CALL_SUCCESS);
}

export function pricingBundlesCallFailed() {
  captureAction(METRICS.PRICING_API_CALL_FAILED);
}

export function pricingBundlesCallOvertime() {
  captureAction(METRICS.PRICING_API_CALL_OVERTIME);
}

export function pricingBundlesCallRecovered() {
  captureAction(METRICS.PRICING_API_CALL_RECOVERED);
}

export function fileUploadStarted() {
  captureAction(METRICS.FILE_UPLOAD_STARTED);
}

export function fileUploadError() {
  captureAction(METRICS.FILE_UPLOAD_FAILURE);
}

export function fileUploadOvertime() {
  captureAction(METRICS.FILE_UPLOAD_OVERTIME);
}

export function fileUploadRecovered() {
  captureAction(METRICS.FILE_UPLOAD_RECOVERED);
}

export function fileUploadSuccess() {
  captureAction(METRICS.FILE_UPLOAD_SUCCESS);
}

export function ppaChatbotStarted() {
  captureAction(METRICS.PPA_CHATBOT_STARTED);
}

export function ppaChatbotSuccess() {
  captureAction(METRICS.PPA_CHATBOT_SUCCESS);
}

export function ppaChatbotFailed() {
  captureAction(METRICS.PPA_CHATBOT_FAILED);
}

export function userNotFound() {
  captureAction(METRICS.USER_NOT_FOUND);
}
